import { uniq } from 'lodash-es';
import { nonNullable, url } from '~/utils';
import type { Tags } from '~/types/modules/contents';
import type { EventSummaryResponseSchema, EventCardTags } from '~/types/modules/event';
import { useStore } from '../useStore';

export const useTags = () => {
  const store = useStore();

  /** タグ名＋urlにフォーマット */
  const mappedTags = async (tags: number[], permalinks?: string[]): Promise<Tags | undefined> => {
    try {
      const tagIds = tags.map((tagId: number) => tagId);
      const tagPermalinks = permalinks?.map((permalink: string) => permalink);
      if (!tagIds.length && !tagPermalinks?.length) return;
      const { result } = await store.dispatch('modules/content/fetchTags', {
        tags: tagIds,
        permalinks: tagPermalinks,
      });
      return result
        ?.map((tag) => ({
          text: tag?.contents.tag_name,
          link: {
            path: url('TAG_SEARCH_LIST'),
            query: { tag: tag?.permalink },
          },
        }))
        ?.filter(nonNullable);
    } catch {
      // 何もしない
    }
  };

  /** イベントid＋タグ名称リストにフォーマット */
  const allTagNames = async (events: EventSummaryResponseSchema[] = []): Promise<EventCardTags[]> => {
    try {
      const { result } = await store.dispatch('modules/content/fetchTags', {
        permalinks: uniq(events.flatMap((event) => event.tags || null)).filter(nonNullable),
      });
      return events.map(({ id, tags = [] }) => {
        const tagTexts = tags
          .map((tagPermalink) => {
            const tag = result?.find((item) => item.permalink === tagPermalink);
            if (!tag) return null;
            return tag.contents.tag_name;
          })
          .filter(nonNullable);
        return {
          id,
          tags: tagTexts,
        };
      });
    } catch {
      // エラーの場合は空配列を返す
      return [];
    }
  };

  /** イベントに紐付いてるタグ名称リストを取得 */
  const findTagsByEventId = (eventId: number, tags: EventCardTags[]) => {
    const foundTags = tags.find((tag) => tag.id === eventId);
    return foundTags?.tags || [];
  };

  return {
    mappedTags,
    allTagNames,
    findTagsByEventId,
  };
};
